export function libsSharedModels(): string {
  return 'libs/shared-models';
}
